import {AfterContentInit, AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {Currencies, Currency, CurrencyService} from './services/currency.service';
import {CurrencyComponent} from './components/currency/currency.component';
import {Rate, RateService} from './services/rate.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, AfterContentInit {
  @ViewChild('left', {static: false}) left: CurrencyComponent;
  @ViewChild('right', {static: false}) right: CurrencyComponent;

  sourceCurrencies: Currency[];
  destinationCurrencies: Currency[];

  public direction: boolean = true;

  private leftAmount: number;
  public leftCurrency: Currency;

  private rightAmount: number;
  public rightCurrency: Currency;

  private rate: Rate;
  public sourceRate: string;
  public destinationRate: string;
  public busy: boolean = false;

  public errors: boolean = false;

  constructor(private currencyService: CurrencyService, private rateService: RateService) {

  }

  ngOnInit(): void {
    this.busy = true;
  }

  ngAfterContentInit(): void {
    this.busy = true;
    this.currencyService.getCurrencies().subscribe((currencies: Currencies) => {
      const sourceCurrencies = currencies.sourceCurrencies.sort((a, b) => a.alpha3.localeCompare(b.alpha3));
      this.sourceCurrencies = sourceCurrencies;
      this.left.setCurrencies(sourceCurrencies);

      const destinationCurrencies = currencies.destinationCurrencies.sort((a, b) => a.alpha3.localeCompare(b.alpha3));
      this.destinationCurrencies = destinationCurrencies;
      this.left.setCurrencies(destinationCurrencies);
      this.busy = false;
      this.errors = false;

      this.loadDefault();

    }, error => {
        console.log(error);
        this.busy = false;
        this.errors = true;
    });
  }

  private loadDefault() {
    this.left.setAmount(100);
    this.left.setCurrency('USD');

    this.right.setCurrency('AUD');
    this.getRate();
    this.leftValueChanged(100);
  }

  leftValueChanged(amount: number) {
    this.direction = true;
    this.leftAmount = amount;

    this.right.setCalculatedAmount(null);
    this.destinationRate = null;

    this.getRate();
  }

  rightValueChanged(amount: number) {
    this.direction = false;
    this.rightAmount = amount;

    this.left.setCalculatedAmount(null);
    this.sourceRate = null;

    this.getRate();
  }

  leftCurrencyChanged(currency: Currency) {
    this.leftCurrency = currency;

    if (this.direction) {
      this.right.setCalculatedAmount(null);
    } else {
      this.left.setCalculatedAmount(null);
    }

    this.sourceRate = null;
    this.destinationRate = null;

    this.getRate();
  }

  rightCurrencyChanged(currency: Currency) {
    this.rightCurrency = currency;

    if (this.direction) {
      this.right.setCalculatedAmount(null);
    } else {
      this.left.setCalculatedAmount(null);
    }

    this.sourceRate = null;
    this.destinationRate = null;

    this.getRate();
  }

  private getRate() {

    let sourceCurrency: Currency;
    let destinationCurrency: Currency;
    let amount;
    let reverse;

    if (this.leftCurrency && this.rightCurrency) {
      if (this.direction && this.leftAmount) {
        sourceCurrency = this.leftCurrency;
        destinationCurrency = this.rightCurrency;
        amount = this.leftAmount;
        reverse = false;
      } else if (!this.direction && this.rightAmount) {
        sourceCurrency = this.leftCurrency;
        destinationCurrency = this.rightCurrency;
        amount = this.rightAmount;
        reverse = true;
      }
    }

    if (sourceCurrency && destinationCurrency && amount) {
      this.busy = true;
      this.rateService.getRate(sourceCurrency.alpha3, destinationCurrency.alpha3, amount, reverse).subscribe(rate => {
        if (rate) {
          rate.sourceCurrency = sourceCurrency.alpha3;
          rate.destinationCurrency = destinationCurrency.alpha3;

          if (this.direction) {
            this.sourceRate = `1 ${rate.sourceCurrency} = ${(+rate.rate).toFixed(6)} ${rate.destinationCurrency}`;
            this.destinationRate = `1 ${rate.destinationCurrency} = ${(1 / rate.rate).toFixed(6)} ${rate.sourceCurrency}`;
          } else {
            this.destinationRate = `1 ${rate.sourceCurrency} = ${(+rate.rate).toFixed(6)} ${rate.destinationCurrency}`;
            this.sourceRate = `1 ${rate.destinationCurrency} = ${(1 / rate.rate).toFixed(6)} ${rate.sourceCurrency}`;
          }

          if (this.direction) {
            this.right.setCalculatedAmount(rate.amount);
          } else {
            this.left.setCalculatedAmount(rate.amount);
          }
        } else {
          console.log("no rate for this currency pair avaiable");
        }

        this.busy = false;
        this.errors = false;
      }, error => {
        console.log(error);
        this.busy = false;
        this.errors = true;
      });
    }
  }

  clearRight() {
    this.right.clear();
  }

  clearLeft() {
    this.left.clear();
  }
}
